const sw = {
	init() {
		'serviceWorker' in navigator && !location.hostname.includes('localhost') && navigator.serviceWorker.register('/sw.js')
	}
}

sw.init()